import { render, staticRenderFns } from "./mtcLinkDown.vue?vue&type=template&id=09cbd9b0&"
import script from "./mtcLinkDown.vue?vue&type=script&lang=js&"
export * from "./mtcLinkDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports